// notification userSettings
import notificationsUserSettings from '../userSettings/userSettings.notification';

const listNotificationsRepository = async () => {
  const notificationSettings = await notificationsUserSettings.getSettings();
  return notificationSettings?.notifications || [];
};

export default listNotificationsRepository;
